export function openLoginModal(origin: 'translation' | 'reaction') {
    window.history.pushState({}, '', `?modal=login&origin=${origin}`)
}
